import axios from "axios";
import * as loggedInUser from "../helpers/auth-service";

export function post(payload) {
    return new Promise(async (resolve, reject) => {
        try {
            const result = await axios.request({
                method: "post",
                url: process.env.REACT_APP_PLATFORM_URL + payload.url,
                data: payload.data,
                headers: { 'Authorization': loggedInUser.getToken() }

            });
            //console.log("add batch",result);
            resolve(result.data);
        } catch (error) {
            reject(error);
        }
    });
}


export function get(payload) {
    return new Promise(async (resolve, reject) => {
        try {
            const result = await axios.request({
                method: "get",
                url: process.env.REACT_APP_PLATFORM_URL + payload.url,
                headers: { 'Authorization': loggedInUser.getToken() }
            });
            //console.log("add batch",result);
            resolve(result.data);
        } catch (error) {
            reject(error);
        }
    });
}